module.exports = __webpack_public_path__ + "media/images/icons/twitter-ed5ddec1aa2bca384872aa434aca186b.svg";